module.exports = __webpack_public_path__ + "img/shipin.f899dc0a.svg";